import { RealizedGainLossDTO } from '../../../AccountPerformanceReporting/api/useRealizedGainLossQuery';
import { UnRealizedGainLossDTO } from '../../../AccountPerformanceReporting/api/useUnrealizedGainLossQuery';
import { TableData } from '../../../AccountPerformanceReporting/hooks/useUnrealizedGainLoss';

export const accountAssetAllocationChartContentMock = {
  name: 'Asset Class',
  chartData: [
    {
      id: 1,
      name: 'Security',
      allocation: 0.0264,
      marketValue: 231675.42,
      color: '#C0C0FF',
    },
    {
      id: 2,
      name: 'Cash and Equivalents',
      allocation: 0,
      marketValue: 0.4,
      color: '#DA1B06',
    },
    {
      id: 3,
      name: 'Common Stock',
      allocation: 0.5307999999999999,
      marketValue: 4666667.16,
      color: '#363E63',
    },
    {
      id: 4,
      name: 'International Stocks',
      allocation: 0.044800000000000006,
      marketValue: 394076.15,
      color: '#A2C78B',
    },
    {
      id: 5,
      name: 'Other',
      allocation: 0.2826,
      marketValue: 2484579.42,
      color: '#1A0C12',
    },
    {
      id: 6,
      name: 'Diversified Emerging Mkts',
      allocation: 0.115,
      marketValue: 1010724.98,
      color: '#F0580D',
    },
    {
      id: 7,
      name: 'Large Growth',
      allocation: 0.0004,
      marketValue: 3744.28,
      color: '#82F929',
    },
    {
      id: 8,
      name: 'Cash or Equivalent',
      allocation: 0,
      marketValue: 281.3,
      color: '#683A67',
    },
  ],
};

export const assetClassAllocationChartContentMock = {
  chartData: [
    {
      id: 1,
      name: 'Dean Martin - XXXXXE-465',
      allocation: 0.38530000000000003,
      marketValue: 3387411.52,
      color: '#0078D4',
    },
    {
      id: 2,
      name: 'Dean Martin - XXXXXE-405',
      allocation: 0.2826,
      marketValue: 2484579.42,
      color: '#7EC4F6',
    },
    {
      id: 3,
      name: 'Dean Martin - XXXXXX-X65_01',
      allocation: 0.14550000000000002,
      marketValue: 1279255.64,
      color: '#9061F9',
    },
    {
      id: 4,
      name: 'Dean Martin - XXXXXX-X65_02',
      allocation: 0.115,
      marketValue: 1010724.98,
      color: '#CABFFD',
    },
    {
      id: 5,
      name: 'Dean And Elizabeth Martin TEST - XXXXXXest1',
      allocation: 0.0702,
      marketValue: 617508.25,
      color: '#0E9F6E',
    },
    {
      id: 6,
      name: 'Dean And Elizabeth Martin TEST - XXXXXXX8911',
      allocation: 0.0014000000000000002,
      marketValue: 12269.3,
      color: '#84E1BC',
    },
  ],
  name: 'Account',
};

export const marketValueChartContentMock = {
  label: 'Market Value as of 1/11/2026',
  value: '$8,791,749.11',
};

export const periodReturnsContentMock = {
  label: '3 Year Return',
  value: '$2,000,100.00',
};

export const activitySummaryDataMock = [
  {
    label: 'Beginning Account Value',
    value: '$7,661,668.45',
    type: 'currency',
    isHighlighted: true,
  },
  {
    label: 'Change In Accrued Income',
    value: '$0.00',
    type: 'currency',
    isHighlighted: false,
  },
  {
    label: 'Market Value Change',
    value: '$512,572.41',
    type: 'currency',
    isHighlighted: false,
  },
  {
    label: 'Ending Account Value',
    value: '$8,174,240.86',
    type: 'currency',
    isHighlighted: true,
  },
];

export const valueVsInvestmentCardMock = {
  data: [
    {
      name: 'Portfolio Value',
      data: [
        [1736726400000, 7672552.43],
        [1736812800000, 7686388.55],
        [1736899200000, 7788238.18],
        [1737072000000, 7842581.13],
        [1737158400000, 7842581.13],
        [1737244800000, 7842581.13],
        [1737331200000, 7842581.13],
        [1737504000000, 7966314.26],
        [1737590400000, 8000920.1],
        [1737676800000, 7984325.82],
        [1737763200000, 7984325.82],
        [1737849600000, 7984325.82],
        [1738022400000, 7986139.15],
        [1738108800000, 7953208.79],
        [1738195200000, 7850995.14],
        [1738281600000, 7819823.69],
        [1738368000000, 7819823.69],
        [1738540800000, 7766760.88],
        [1738627200000, 7788299.78],
        [1738713600000, 7807693.83],
        [1738800000000, 7806016.73],
        [1738972800000, 7741039.01],
        [1739059200000, 7741039.01],
        [1739145600000, 7771908.53],
        [1739232000000, 7794741.73],
        [1739318400000, 7752752.91],
        [1739491200000, 7776929.39],
        [1739577600000, 7776929.39],
        [1739664000000, 7776929.39],
        [1739750400000, 7776929.39],
        [1739923200000, 7817604.54],
        [1740009600000, 7816404.01],
        [1740096000000, 7741234.21],
        [1740182400000, 7741234.21],
        [1740268800000, 7741234.21],
        [1740441600000, 7704211.1],
        [1740528000000, 7711877.52],
        [1740614400000, 7653498.77],
        [1740700800000, 7714686.03],
        [1740787200000, 7714686.03],
        [1740960000000, 7643770.64],
        [1741046400000, 7578498.5],
        [1741132800000, 7680350.59],
        [1741219200000, 7637968.96],
        [1741392000000, 7646499],
        [1741478400000, 7646499],
        [1741564800000, 7531294.99],
        [1741651200000, 7466441.78],
        [1741737600000, 7462435.79],
        [1741910400000, 7505059.9],
        [1741996800000, 7505059.9],
        [1742083200000, 7505059.9],
        [1742169600000, 7547444.93],
        [1742342400000, 7539223.45],
        [1742428800000, 7523000.58],
        [1742515200000, 7533217.44],
        [1742601600000, 7533217.44],
        [1742688000000, 7533217.44],
        [1742860800000, 7586416.28],
        [1742947200000, 7553745.18],
        [1743033600000, 7553562.35],
        [1743120000000, 7444081.97],
        [1743206400000, 7444081.97],
        [1743375600000, 7459633.75],
        [1743462000000, 7502516.73],
        [1743548400000, 7524275.09],
        [1743634800000, 7311082.27],
        [1743807600000, 7057043.32],
        [1743894000000, 7057043.32],
        [1743980400000, 6989304.61],
        [1744066800000, 6913682.79],
        [1744153200000, 7324611.12],
        [1744326000000, 7271646.25],
        [1744412400000, 7271646.25],
        [1744498800000, 7271646.25],
        [1744585200000, 7308315.82],
        [1744758000000, 7160148.56],
        [1744844400000, 7192546.14],
        [1744930800000, 7192546.14],
        [1745017200000, 7192546.14],
        [1745103600000, 7192546.14],
        [1745276400000, 7216564.45],
        [1745362800000, 7256728.38],
        [1745449200000, 7355140.17],
        [1745535600000, 7368286.99],
        [1745622000000, 7368286.99],
        [1745794800000, 7368217.17],
        [1745881200000, 7380266.71],
        [1745967600000, 7394691.33],
        [1746054000000, 7513726.59],
        [1746226800000, 7603027.92],
        [1746313200000, 7603027.92],
        [1746399600000, 7589221.94],
        [1746486000000, 7550571.86],
        [1746572400000, 6026851.61],
        [1746745200000, 7612337.74],
        [1746831600000, 7612337.74],
        [1746918000000, 7612337.74],
        [1747004400000, 7766254.65],
        [1747177200000, 7767139.87],
        [1747263600000, 7801831.26],
        [1747350000000, 7828283.95],
        [1747436400000, 7828283.95],
        [1747522800000, 7828283.95],
        [1747695600000, 7876615.15],
        [1747782000000, 7793346.18],
        [1747868400000, 7793346.18],
        [1747954800000, 7793346.18],
        [1748041200000, 7793346.18],
        [1748214000000, 7793346.18],
        [1748300400000, 7793346.18],
        [1748386800000, 7823945.43],
        [1748473200000, 7838961.89],
        [1748646000000, 7850406.68],
        [1748732400000, 7850406.68],
        [1748818800000, 7852386.36],
        [1748905200000, 7875097.24],
        [1748991600000, 7877998.73],
        [1749164400000, 7909229.04],
        [1749250800000, 7909229.04],
        [1749337200000, 7909229.04],
        [1749423600000, 7913471.65],
        [1749596400000, 7913578.15],
        [1749682800000, 7951339.48],
        [1749769200000, 7892513.24],
        [1749855600000, 7892513.24],
        [1749942000000, 7892513.24],
        [1750114800000, 7891250.97],
        [1750201200000, 7904553.81],
        [1750287600000, 7904553.81],
        [1750374000000, 7898312.65],
        [1750460400000, 7898312.65],
        [1750633200000, 7970281.28],
        [1750719600000, 8006629.14],
        [1750806000000, 8006067.62],
        [1750892400000, 8045234.34],
        [1751065200000, 6136903.58],
        [1751151600000, 6136903.58],
        [1751238000000, 6136903.58],
        [1751324400000, 6136903.58],
        [1751410800000, 6136903.58],
        [1751583600000, 6136903.58],
        [1751670000000, 6136903.58],
        [1751756400000, 6136903.58],
        [1751842800000, 6136903.58],
        [1752015600000, 6136903.58],
        [1752102000000, 6136903.58],
        [1752188400000, 6136903.58],
        [1752274800000, 6136903.58],
        [1752361200000, 6136903.58],
        [1752534000000, 6136903.58],
        [1752620400000, 6136903.58],
        [1752706800000, 6136903.58],
        [1752793200000, 6136903.58],
        [1752879600000, 6136903.58],
        [1753052400000, 6136903.58],
        [1753138800000, 6136903.58],
        [1753225200000, 6136903.58],
        [1753311600000, 6136903.58],
        [1753484400000, 6136903.58],
        [1753570800000, 6136903.58],
        [1753657200000, 6136903.58],
        [1753743600000, 6136903.58],
        [1753830000000, 6164391.9],
        [1754002800000, 6132617.51],
        [1754089200000, 6132617.51],
        [1754175600000, 6132617.51],
        [1754262000000, 8269192.63],
        [1754434800000, 7991273.64],
        [1754521200000, 7976322.64],
        [1754607600000, 8236663.06],
        [1754694000000, 8236663.06],
        [1754780400000, 8236663.06],
        [1754953200000, 8293964.8],
        [1755039600000, 8285693.64],
        [1755126000000, 8243114.13],
        [1755212400000, 8258502.04],
        [1755298800000, 8258502.04],
        [1755471600000, 8243081.73],
        [1755558000000, 6214750.43],
        [1755644400000, 8212962.67],
        [1755730800000, 8189542.72],
        [1755903600000, 8254361.24],
        [1755990000000, 8254361.24],
        [1756076400000, 6222728.39],
        [1756162800000, 8182204.18],
        [1756249200000, 8239134.45],
        [1756422000000, 8229138.47],
        [1756508400000, 8229138.47],
        [1756594800000, 8229138.47],
        [1756681200000, 8229138.47],
        [1756854000000, 8206089.82],
        [1756940400000, 8245623.94],
        [1757026800000, 8190328.26],
        [1757113200000, 8190328.26],
        [1757199600000, 8190328.26],
        [1757372400000, 8253673.59],
        [1757458800000, 8253582.36],
        [1757545200000, 8293271.67],
        [1757631600000, 8319666.32],
        [1757718000000, 8319666.32],
        [1757890800000, 6238324.52],
        [1757977200000, 8312293.66],
        [1758063600000, 8333777.47],
        [1758150000000, 8317008.74],
        [1758322800000, 8354888.61],
        [1758409200000, 8354888.61],
        [1758495600000, 8331667.77],
        [1758582000000, 8329187.4],
        [1758668400000, 8303800.56],
        [1758841200000, 8309480.78],
        [1758927600000, 8309480.78],
        [1759014000000, 8309480.78],
        [1759100400000, 6241978.63],
        [1759273200000, 6241748.24],
        [1759359600000, 8320661.41],
        [1759446000000, 8332517.01],
        [1759532400000, 8332517.01],
        [1759618800000, 8332517.01],
        [1759791600000, 8346127.46],
        [1759878000000, 8343617.54],
        [1759964400000, 8303999.92],
        [1760050800000, 8194810.47],
        [1760137200000, 8194810.47],
        [1760310000000, 8231387.15],
        [1760396400000, 8274876.49],
        [1760482800000, 8276995.91],
        [1760569200000, 8259525.29],
        [1760742000000, 8295668.81],
        [1760828400000, 8295668.81],
        [1760914800000, 8320364.92],
        [1761001200000, 8339538.16],
        [1761087600000, 6223884.09],
        [1761260400000, 8395570.11],
        [1761346800000, 8395570.11],
        [1761433200000, 8395570.11],
        [1761523200000, 8452158.93],
        [1761696000000, 8450377.23],
        [1761782400000, 8366280.45],
        [1761868800000, 8326628.89],
        [1761955200000, 8326628.89],
        [1762041600000, 8326628.89],
        [1762214400000, 8282138.96],
        [1762300800000, 8254292],
        [1762387200000, 8177926.09],
        [1762473600000, 8193152.86],
        [1762560000000, 8193152.86],
        [1762732800000, 6219748.21],
        [1762819200000, 8290707.23],
        [1762905600000, 8311599.16],
        [1762992000000, 8238269.7],
        [1763164800000, 8238269.7],
        [1763251200000, 8238269.7],
        [1763337600000, 8238269.7],
        [1763424000000, 6193516.78],
        [1763510400000, 8099803.76],
        [1763683200000, 8053329.62],
        [1763769600000, 8053329.62],
        [1763856000000, 8053329.62],
        [1763942400000, 8051248.84],
        [1764115200000, 8179588.69],
        [1764201600000, 8179588.69],
        [1764288000000, 8227764.59],
        [1764374400000, 8227764.59],
        [1764460800000, 8227764.59],
        [1764633600000, 8200941.18],
        [1764720000000, 8179726.35],
        [1764806400000, 8187382.8],
        [1764892800000, 8103834.15],
        [1764979200000, 8103834.15],
        [1765152000000, 8112731.38],
        [1765238400000, 8110177.33],
        [1765324800000, 8093355.81],
        [1765411200000, 8105934.24],
        [1765584000000, 8108619.5],
        [1765670400000, 8108619.5],
        [1765756800000, 8058492.87],
        [1765843200000, 8065705.64],
        [1765929600000, 8049512.3],
        [1766102400000, 8119893.66],
        [1766188800000, 8119893.66],
        [1766275200000, 8119893.66],
        [1766361600000, 7030324.04],
        [1766534400000, 7056160.9],
        [1766620800000, 7056160.9],
        [1766707200000, 8167374.5],
        [1766793600000, 8167374.5],
        [1766880000000, 8167374.5],
        [1767052800000, 8150530.71],
        [1767139200000, 8107973.75],
        [1767225600000, 8107973.75],
        [1767312000000, 8086106.18],
        [1767398400000, 8086106.18],
        [1767571200000, 8108059.44],
        [1767657600000, 8124106.69],
        [1767744000000, 8107504.12],
        [1767830400000, 8174240.86],
        [1768003200000, 8221321.72],
        [1768089600000, 8221321.72],
        [1768176000000, 8221321.72],
      ],
    },
    {
      name: 'Net Amount Invested',
      data: [
        [1736726400000, 2055371.52],
        [1736812800000, 2055371.52],
        [1736899200000, 2055371.52],
        [1737072000000, 2055371.52],
        [1737158400000, 2055371.52],
        [1737244800000, 2055371.52],
        [1737331200000, 2055371.52],
        [1737504000000, 2055371.52],
        [1737590400000, 2055371.52],
        [1737676800000, 2055371.52],
        [1737763200000, 2055371.52],
        [1737849600000, 2055371.52],
        [1738022400000, 2055371.52],
        [1738108800000, 2055371.52],
        [1738195200000, 2055371.52],
        [1738281600000, 2055371.52],
        [1738368000000, 2055371.52],
        [1738540800000, 2055371.52],
        [1738627200000, 2055371.52],
        [1738713600000, 2055371.52],
        [1738800000000, 2055371.52],
        [1738972800000, 2055371.52],
        [1739059200000, 2055371.52],
        [1739145600000, 2055371.52],
        [1739232000000, 2055371.52],
        [1739318400000, 2055371.52],
        [1739491200000, 2055371.52],
        [1739577600000, 2055371.52],
        [1739664000000, 2055371.52],
        [1739750400000, 2055371.52],
        [1739923200000, 2055371.52],
        [1740009600000, 2055371.52],
        [1740096000000, 2055371.52],
        [1740182400000, 2055371.52],
        [1740268800000, 2055371.52],
        [1740441600000, 2055371.52],
        [1740528000000, 2055371.52],
        [1740614400000, 2055371.52],
        [1740700800000, 2055371.52],
        [1740787200000, 2055371.52],
        [1740960000000, 2055371.52],
        [1741046400000, 2055371.52],
        [1741132800000, 2055371.52],
        [1741219200000, 2055371.52],
        [1741392000000, 2055371.52],
        [1741478400000, 2055371.52],
        [1741564800000, 2055371.52],
        [1741651200000, 2055371.52],
        [1741737600000, 2055371.52],
        [1741910400000, 2055371.52],
        [1741996800000, 2055371.52],
        [1742083200000, 2055371.52],
        [1742169600000, 2055371.52],
        [1742342400000, 2055371.52],
        [1742428800000, 2055371.52],
        [1742515200000, 2055371.52],
        [1742601600000, 2055371.52],
        [1742688000000, 2055371.52],
        [1742860800000, 2055371.52],
        [1742947200000, 2055371.52],
        [1743033600000, 2055371.52],
        [1743120000000, 2055371.52],
        [1743206400000, 2055371.52],
        [1743375600000, 2055371.52],
        [1743462000000, 2055371.52],
        [1743548400000, 2055371.52],
        [1743634800000, 2055371.52],
        [1743807600000, 2055371.52],
        [1743894000000, 2055371.52],
        [1743980400000, 2055371.52],
        [1744066800000, 2055371.52],
        [1744153200000, 2055371.52],
        [1744326000000, 2055371.52],
        [1744412400000, 2055371.52],
        [1744498800000, 2055371.52],
        [1744585200000, 2055371.52],
        [1744758000000, 2055371.52],
        [1744844400000, 2055371.52],
        [1744930800000, 2055371.52],
        [1745017200000, 2055371.52],
        [1745103600000, 2055371.52],
        [1745276400000, 2055371.52],
        [1745362800000, 2055371.52],
        [1745449200000, 2055371.52],
        [1745535600000, 2055371.52],
        [1745622000000, 2055371.52],
        [1745794800000, 2055371.52],
        [1745881200000, 2055371.52],
        [1745967600000, 2055371.52],
        [1746054000000, 2055371.52],
        [1746226800000, 2055371.52],
        [1746313200000, 2055371.52],
        [1746399600000, 2055371.52],
        [1746486000000, 2055371.52],
        [1746572400000, 2055371.52],
        [1746745200000, 2055371.52],
        [1746831600000, 2055371.52],
        [1746918000000, 2055371.52],
        [1747004400000, 2055371.52],
        [1747177200000, 2055371.52],
        [1747263600000, 2055371.52],
        [1747350000000, 2055371.52],
        [1747436400000, 2055371.52],
        [1747522800000, 2055371.52],
        [1747695600000, 2055371.52],
        [1747782000000, 2055371.52],
        [1747868400000, 2055371.52],
        [1747954800000, 2055371.52],
        [1748041200000, 2055371.52],
        [1748214000000, 2055371.52],
        [1748300400000, 2055371.52],
        [1748386800000, 2055371.52],
        [1748473200000, 2055371.52],
        [1748646000000, 2055371.52],
        [1748732400000, 2055371.52],
        [1748818800000, 2055371.52],
        [1748905200000, 2055371.52],
        [1748991600000, 2055371.52],
        [1749164400000, 2055371.52],
        [1749250800000, 2055371.52],
        [1749337200000, 2055371.52],
        [1749423600000, 2055371.52],
        [1749596400000, 2055371.52],
        [1749682800000, 2055371.52],
        [1749769200000, 2055371.52],
        [1749855600000, 2055371.52],
        [1749942000000, 2055371.52],
        [1750114800000, 2055371.52],
        [1750201200000, 2055371.52],
        [1750287600000, 2055371.52],
        [1750374000000, 2055371.52],
        [1750460400000, 2055371.52],
        [1750633200000, 2055371.52],
        [1750719600000, 2055371.52],
        [1750806000000, 2055371.52],
        [1750892400000, 2055371.52],
        [1751065200000, 2055371.52],
        [1751151600000, 2055371.52],
        [1751238000000, 2055371.52],
        [1751324400000, 2055371.52],
        [1751410800000, 2055371.52],
        [1751583600000, 2055371.52],
        [1751670000000, 2055371.52],
        [1751756400000, 2055371.52],
        [1751842800000, 2055371.52],
        [1752015600000, 2055371.52],
        [1752102000000, 2055371.52],
        [1752188400000, 2055371.52],
        [1752274800000, 2055371.52],
        [1752361200000, 2055371.52],
        [1752534000000, 2055371.52],
        [1752620400000, 2055371.52],
        [1752706800000, 2055371.52],
        [1752793200000, 2055371.52],
        [1752879600000, 2055371.52],
        [1753052400000, 2055371.52],
        [1753138800000, 2055371.52],
        [1753225200000, 2055371.52],
        [1753311600000, 2055371.52],
        [1753484400000, 2055371.52],
        [1753570800000, 2055371.52],
        [1753657200000, 2055371.52],
        [1753743600000, 2055371.52],
        [1753830000000, 2055371.52],
        [1754002800000, 2055371.52],
        [1754089200000, 2055371.52],
        [1754175600000, 2055371.52],
        [1754262000000, 2055371.52],
        [1754434800000, 2055371.52],
        [1754521200000, 2055371.52],
        [1754607600000, 2055371.52],
        [1754694000000, 2055371.52],
        [1754780400000, 2055371.52],
        [1754953200000, 2055371.52],
        [1755039600000, 2055371.52],
        [1755126000000, 2055371.52],
        [1755212400000, 2055371.52],
        [1755298800000, 2055371.52],
        [1755471600000, 2055371.52],
        [1755558000000, 2055371.52],
        [1755644400000, 2055371.52],
        [1755730800000, 2055371.52],
        [1755903600000, 2055371.52],
        [1755990000000, 2055371.52],
        [1756076400000, 2055371.52],
        [1756162800000, 2055371.52],
        [1756249200000, 2055371.52],
        [1756422000000, 2055371.52],
        [1756508400000, 2055371.52],
        [1756594800000, 2055371.52],
        [1756681200000, 2055371.52],
        [1756854000000, 2055371.52],
        [1756940400000, 2055371.52],
        [1757026800000, 2055371.52],
        [1757113200000, 2055371.52],
        [1757199600000, 2055371.52],
        [1757372400000, 2055371.52],
        [1757458800000, 2055371.52],
        [1757545200000, 2055371.52],
        [1757631600000, 2055371.52],
        [1757718000000, 2055371.52],
        [1757890800000, 2055371.52],
        [1757977200000, 2055371.52],
        [1758063600000, 2055371.52],
        [1758150000000, 2055371.52],
        [1758322800000, 2055371.52],
        [1758409200000, 2055371.52],
        [1758495600000, 2055371.52],
        [1758582000000, 2055371.52],
        [1758668400000, 2055371.52],
        [1758841200000, 2055371.52],
        [1758927600000, 2055371.52],
        [1759014000000, 2055371.52],
        [1759100400000, 2055371.52],
        [1759273200000, 2055371.52],
        [1759359600000, 2055371.52],
        [1759446000000, 2055371.52],
        [1759532400000, 2055371.52],
        [1759618800000, 2055371.52],
        [1759791600000, 2055371.52],
        [1759878000000, 2055371.52],
        [1759964400000, 2055371.52],
        [1760050800000, 2055371.52],
        [1760137200000, 2055371.52],
        [1760310000000, 2055371.52],
        [1760396400000, 2055371.52],
        [1760482800000, 2055371.52],
        [1760569200000, 2055371.52],
        [1760742000000, 2055371.52],
        [1760828400000, 2055371.52],
        [1760914800000, 2055371.52],
        [1761001200000, 2055371.52],
        [1761087600000, 2055371.52],
        [1761260400000, 2055371.52],
        [1761346800000, 2055371.52],
        [1761433200000, 2055371.52],
        [1761523200000, 2055371.52],
        [1761696000000, 2055371.52],
        [1761782400000, 2055371.52],
        [1761868800000, 2055371.52],
        [1761955200000, 2055371.52],
        [1762041600000, 2055371.52],
        [1762214400000, 2055371.52],
        [1762300800000, 2055371.52],
        [1762387200000, 2055371.52],
        [1762473600000, 2055371.52],
        [1762560000000, 2055371.52],
        [1762732800000, 2055371.52],
        [1762819200000, 2055371.52],
        [1762905600000, 2055371.52],
        [1762992000000, 2055371.52],
        [1763164800000, 2055371.52],
        [1763251200000, 2055371.52],
        [1763337600000, 2055371.52],
        [1763424000000, 2055371.52],
        [1763510400000, 2055371.52],
        [1763683200000, 2055371.52],
        [1763769600000, 2055371.52],
        [1763856000000, 2055371.52],
        [1763942400000, 2055371.52],
        [1764115200000, 2055371.52],
        [1764201600000, 2055371.52],
        [1764288000000, 2055371.52],
        [1764374400000, 2055371.52],
        [1764460800000, 2055371.52],
        [1764633600000, 2055371.52],
        [1764720000000, 2055371.52],
        [1764806400000, 2055371.52],
        [1764892800000, 2055371.52],
        [1764979200000, 2055371.52],
        [1765152000000, 2055371.52],
        [1765238400000, 2055371.52],
        [1765324800000, 2055371.52],
        [1765411200000, 2055371.52],
        [1765584000000, 2055371.52],
        [1765670400000, 2055371.52],
        [1765756800000, 2055371.52],
        [1765843200000, 2055371.52],
        [1765929600000, 2055371.52],
        [1766102400000, 2055371.52],
        [1766188800000, 2055371.52],
        [1766275200000, 2055371.52],
        [1766361600000, 2055371.52],
        [1766534400000, 2055371.52],
        [1766620800000, 2055371.52],
        [1766707200000, 2055371.52],
        [1766793600000, 2055371.52],
        [1766880000000, 2055371.52],
        [1767052800000, 2055371.52],
        [1767139200000, 2055371.52],
        [1767225600000, 2055371.52],
        [1767312000000, 2055371.52],
        [1767398400000, 2055371.52],
        [1767571200000, 2055371.52],
        [1767657600000, 2055371.52],
        [1767744000000, 2055371.52],
        [1767830400000, 2055371.52],
        [1768003200000, 2055371.52],
        [1768089600000, 2055371.52],
        [1768176000000, 2055371.52],
      ],
    },
  ],
  portfolioReturn: 7.34,
  setSelectedDate: () => {},
};

export const performanceSummaryMock = [
  {
    label: 'Beginning Account Value',
    value: '$7,661,668.45',
    type: 'currency',
    isHighlighted: true,
  },
  {
    label: 'Change In Accrued Income',
    value: '$0.00',
    type: 'currency',
    isHighlighted: false,
  },
  {
    label: 'Market Value Change',
    value: '$559,653.27',
    type: 'currency',
    isHighlighted: false,
  },
  {
    label: 'Ending Account Value',
    value: '$8,221,321.72',
    type: 'currency',
    isHighlighted: true,
  },
];

export const performanceVSBenchmarkMock = [
  {
    name: 'Managed Accounts',
    data: [
      [1736812800000, 0.0018033268749999554],
      [1737936000000, 0.03711927322700004],
      [1738972800000, 0.008926179471999918],
      [1740096000000, 0.008951620810000005],
      [1741132800000, 0.0010163710280000071],
      [1742256000000, -0.022462365891000036],
      [1743292800000, -0.029777634246999973],
      [1744412400000, -0.05225199614599996],
      [1745449200000, -0.041369839162999966],
      [1746572400000, -0.21449196144500005],
      [1747695600000, 0.026596458201000095],
      [1748732400000, 0.02318058450900007],
      [1749855600000, 0.028668531366000005],
      [1750892400000, 0.04857339371700009],
      [1752015600000, -0.200148368357],
      [1753052400000, -0.200148368357],
      [1754175600000, -0.20070699210599996],
      [1755212400000, 0.07636958044199993],
      [1756335600000, 0.07529983995199996],
      [1757372400000, 0.07574026574600001],
      [1758495600000, 0.08590561563600008],
      [1759618800000, 0.08601630109700009],
      [1760655600000, 0.0812137011359999],
      [1761782400000, 0.09041684971600006],
      [1762819200000, 0.08056703497799989],
      [1763942400000, 0.049357291912],
      [1764979200000, 0.056210983755],
      [1766102400000, 0.05841142843200009],
      [1767139200000, 0.056857692694000095],
      [1768262400000, 0.06541540066200002],
    ],
    color: '#0078D4',
  },
  {
    name: 'S&P 500 TEST',
    data: [
      [1736812800000, 0.0011487997329999722],
      [1737936000000, 0.030476348641000017],
      [1738972800000, 0.03306215574299998],
      [1740096000000, 0.03174436950900006],
      [1741132800000, 0.002842456835999929],
      [1742256000000, -0.03552979478999996],
      [1743292800000, -0.041092260597999974],
      [1744412400000, -0.07794258543599997],
      [1745449200000, -0.09071403213600004],
      [1746572400000, -0.09071403213600004],
      [1747695600000, -0.09071403213600004],
      [1748732400000, -0.09071403213600004],
      [1749855600000, -0.09071403213600004],
      [1750892400000, -0.09071403213600004],
      [1752015600000, -0.09071403213600004],
      [1753052400000, -0.09071403213600004],
      [1754175600000, -0.09071403213600004],
      [1755212400000, -0.09071403213600004],
      [1756335600000, -0.09071403213600004],
      [1757372400000, -0.09071403213600004],
      [1758495600000, -0.09071403213600004],
      [1759618800000, -0.09071403213600004],
      [1760655600000, -0.09071403213600004],
      [1761782400000, -0.09071403213600004],
      [1762819200000, -0.09071403213600004],
      [1763942400000, -0.09071403213600004],
      [1764979200000, -0.09071403213600004],
      [1766102400000, -0.09071403213600004],
      [1767139200000, -0.09071403213600004],
      [1768262400000, -0.09071403213600004],
    ],
    color: '#51FF00',
  },
  {
    name: 'T-Bill Index',
    data: [
      [1736812800000, 0.00011954581700002187],
      [1737936000000, 0.0016398012070000245],
      [1738972800000, 0.003151094264000065],
      [1740096000000, 0.00480642668799991],
      [1741132800000, 0.005985842632000082],
      [1742256000000, 0.007533675104000048],
      [1743292800000, 0.008938769755999942],
      [1744412400000, 0.010587013551000002],
      [1745449200000, 0.011672862214000101],
      [1746572400000, 0.011672862214000101],
      [1747695600000, 0.011672862214000101],
      [1748732400000, 0.011672862214000101],
      [1749855600000, 0.011672862214000101],
      [1750892400000, 0.011672862214000101],
      [1752015600000, 0.011672862214000101],
      [1753052400000, 0.011672862214000101],
      [1754175600000, 0.011672862214000101],
      [1755212400000, 0.011672862214000101],
      [1756335600000, 0.011672862214000101],
      [1757372400000, 0.011672862214000101],
      [1758495600000, 0.011672862214000101],
      [1759618800000, 0.011672862214000101],
      [1760655600000, 0.011672862214000101],
      [1761782400000, 0.011672862214000101],
      [1762819200000, 0.011672862214000101],
      [1763942400000, 0.011672862214000101],
      [1764979200000, 0.011672862214000101],
      [1766102400000, 0.011672862214000101],
      [1767139200000, 0.011672862214000101],
      [1768262400000, 0.011672862214000101],
    ],
    color: '#9061F9',
  },
  {
    name: 'EFA',
    data: [
      [1736812800000, 0.0036492909290000153],
      [1737936000000, 0.060057056088999916],
      [1738972800000, 0.07096272497199996],
      [1740096000000, 0.09698502479700011],
      [1741132800000, 0.11914476927500006],
      [1742256000000, 0.1278185698979999],
      [1743292800000, 0.10060962195200007],
      [1744412400000, 0.031617460205000114],
      [1745449200000, 0.0856353169470001],
      [1746572400000, 0.0856353169470001],
      [1747695600000, 0.0856353169470001],
      [1748732400000, 0.0856353169470001],
      [1749855600000, 0.0856353169470001],
      [1750892400000, 0.0856353169470001],
      [1752015600000, 0.0856353169470001],
      [1753052400000, 0.0856353169470001],
      [1754175600000, 0.0856353169470001],
      [1755212400000, 0.0856353169470001],
      [1756335600000, 0.0856353169470001],
      [1757372400000, 0.0856353169470001],
      [1758495600000, 0.0856353169470001],
      [1759618800000, 0.0856353169470001],
      [1760655600000, 0.0856353169470001],
      [1761782400000, 0.0856353169470001],
      [1762819200000, 0.0856353169470001],
      [1763942400000, 0.0856353169470001],
      [1764979200000, 0.0856353169470001],
      [1766102400000, 0.0856353169470001],
      [1767139200000, 0.0856353169470001],
      [1768262400000, 0.0856353169470001],
    ],
    color: '#CABFFD',
  },
  {
    name: 'Custom Blend',
    data: [
      [1736812800000, 0.0025477621109999404],
      [1737936000000, 0.03648437325999998],
      [1738972800000, 0.04181380587299999],
      [1740096000000, 0.0475959733989999],
      [1741132800000, 0.026480903511999943],
      [1742256000000, 0.0004061072179999403],
      [1743292800000, -0.008547305135999994],
      [1744412400000, -0.04968844375799997],
      [1745449200000, -0.04899297067899999],
      [1746572400000, -0.04899297067899999],
      [1747695600000, -0.04899297067899999],
      [1748732400000, -0.04899297067899999],
      [1749855600000, -0.04899297067899999],
      [1750892400000, -0.04899297067899999],
      [1752015600000, -0.04899297067899999],
      [1753052400000, -0.04899297067899999],
      [1754175600000, -0.04899297067899999],
      [1755212400000, -0.04899297067899999],
      [1756335600000, -0.04899297067899999],
      [1757372400000, -0.04899297067899999],
      [1758495600000, -0.04899297067899999],
      [1759618800000, -0.04899297067899999],
      [1760655600000, -0.04899297067899999],
      [1761782400000, -0.04899297067899999],
      [1762819200000, -0.04899297067899999],
      [1763942400000, -0.04899297067899999],
      [1764979200000, -0.04899297067899999],
      [1766102400000, -0.04899297067899999],
      [1767139200000, -0.04899297067899999],
      [1768262400000, -0.04899297067899999],
    ],
    color: '#0E9F6E',
  },
  {
    name: 'S&P 100',
    data: [
      [1736812800000, -0.0023280857499999863],
      [1737936000000, 0.025662773385999982],
      [1738972800000, 0.027698017912000106],
      [1740096000000, 0.030272511945000025],
      [1741132800000, -0.003338431962999988],
      [1742256000000, -0.04906299148399995],
      [1743292800000, -0.054058234993],
      [1744412400000, -0.08647421146799994],
      [1745449200000, -0.10629094903699998],
      [1746572400000, -0.10629094903699998],
      [1747695600000, -0.10629094903699998],
      [1748732400000, -0.10629094903699998],
      [1749855600000, -0.10629094903699998],
      [1750892400000, -0.10629094903699998],
      [1752015600000, -0.10629094903699998],
      [1753052400000, -0.10629094903699998],
      [1754175600000, -0.10629094903699998],
      [1755212400000, -0.10629094903699998],
      [1756335600000, -0.10629094903699998],
      [1757372400000, -0.10629094903699998],
      [1758495600000, -0.10629094903699998],
      [1759618800000, -0.10629094903699998],
      [1760655600000, -0.10629094903699998],
      [1761782400000, -0.10629094903699998],
      [1762819200000, -0.10629094903699998],
      [1763942400000, -0.10629094903699998],
      [1764979200000, -0.10629094903699998],
      [1766102400000, -0.10629094903699998],
      [1767139200000, -0.10629094903699998],
      [1768262400000, -0.10629094903699998],
    ],
    color: '#84E1BC',
  },
];

export const performanceDetailsCardMock = {
  data: {
    tableData: {
      headers: [
        {
          text: 'Holding',
        },
        {
          text: 'Market Value',
        },
        {
          text: 'Period',
        },
        {
          text: 'QTD',
        },
        {
          text: 'YTD',
        },
        {
          text: '1 Year',
        },
      ],
      rows: [
        {
          id: '58',
          cells: [
            {
              text: 'Dean Martin - Roth',
            },
            {
              text: '$5,669,855.09',
            },
            {
              text: '8.29%',
            },
            {
              text: '0.96%',
            },
            {
              text: '0.96%',
            },
            {
              text: '8.29%',
            },
          ],
          color: '#5abee4',
          childRows: [
            {
              cells: [
                {
                  text: 'Boeing Co',
                },
                {
                  text: '$3,392,073.67',
                },
                {
                  text: '9.65%',
                },
                {
                  text: '1.96%',
                },
                {
                  text: '1.96%',
                },
                {
                  text: '9.65%',
                },
              ],
            },
            {
              cells: [
                {
                  text: 'Procter & Gamble Co',
                },
                {
                  text: '$1,278,536.99',
                },
                {
                  text: '4.64%',
                },
                {
                  text: '0.65%',
                },
                {
                  text: '0.65%',
                },
                {
                  text: '4.64%',
                },
              ],
            },
            {
              cells: [
                {
                  text: 'Invesco Developing Markets A',
                },
                {
                  text: '$999,244.43',
                },
                {
                  text: '8.57%',
                },
                {
                  text: '-1.91%',
                },
                {
                  text: '-1.91%',
                },
                {
                  text: '8.57%',
                },
              ],
            },
          ],
        },
        {
          id: '59',
          cells: [
            {
              text: 'Dean Martin - 401(K)',
            },
            {
              text: '$2,489,408.70',
            },
            {
              text: '3.53%',
            },
            {
              text: '0.47%',
            },
            {
              text: '0.47%',
            },
            {
              text: '3.53%',
            },
          ],
          color: '#ff7f00',
          childRows: [
            {
              cells: [
                {
                  text: 'Performance Asset',
                },
                {
                  text: '$2,489,408.70',
                },
                {
                  text: '3.53%',
                },
                {
                  text: '0.47%',
                },
                {
                  text: '0.47%',
                },
                {
                  text: '3.53%',
                },
              ],
            },
          ],
        },
        {
          id: '60',
          cells: [
            {
              text: 'Dean And Elizabeth Martin TEST - Roth',
            },
            {
              text: '$12,269.30',
            },
            {
              text: '-58.53%',
            },
            {
              text: '0.00%',
            },
            {
              text: '0.00%',
            },
            {
              text: '-58.53%',
            },
          ],
          color: '#8a65ff',
          childRows: [
            {
              cells: [
                {
                  text: '3FDIC Insured Deposit 2 At Union Bank HSA',
                },
                {
                  text: '$7,515.82',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
              ],
            },
            {
              cells: [
                {
                  text: 'Fidelity OTC',
                },
                {
                  text: '$3,744.28',
                },
                {
                  text: '-76.69%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '-76.69%',
                },
              ],
            },
            {
              cells: [
                {
                  text: 'FDIC Insured Deposit at Suntrust Bk',
                },
                {
                  text: '$507.50',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
              ],
            },
            {
              cells: [
                {
                  text: 'Fidelity Cash Fund**',
                },
                {
                  text: '$281.30',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
              ],
            },
            {
              cells: [
                {
                  text: 'Fdic Insured Deposit At Wells Fargo Hsa Not Covered By Sipc',
                },
                {
                  text: '$220.00',
                },
                {
                  text: '-95.79%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '-95.79%',
                },
              ],
            },
            {
              cells: [
                {
                  text: 'Fidelity Cash Fund',
                },
                {
                  text: '$0.40',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
                {
                  text: '0.00%',
                },
              ],
            },
          ],
        },
        {
          cells: [
            {
              text: 'Managed Accounts',
            },
            {
              text: '$8,171,533.09',
            },
            {
              text: '6.54%',
            },
            {
              text: '0.81%',
            },
            {
              text: '0.81%',
            },
            {
              text: '6.54%',
            },
          ],
          isTotal: true,
        },
      ],
    },
    tabList: [
      'Account',
      'Asset Category',
      'Asset Class',
      'Asset Level Strategy',
      'Management Style',
      'Model',
      'Portfolio Group',
      'Registration',
    ],
    defaultTabIndex: 7,
  },
  searchTerm: '',
  selectedTabIndex: null,
  title: 'Performance Details',
  isRowExpanded: () => false,
  setSearchTerm: () => {},
  setSelectedTabIndex: _ => {},
  setSorting: () => {},
  sorting: {},
  toggleRow: _ => {},
  debouncedSearchTerm: '',
};

export const performanceChartMock = {
  data: {
    series: [
      {
        data: [
          {
            color: '#0078D4',
            name: 'Dean Martin - Roth',
            y: 0.080923532997,
          },
          {
            color: '#7EC4F6',
            name: 'Dean Martin - 401(K)',
            y: 0.032746975386,
          },
          {
            color: '#9061F9',
            name: 'Dean And Elizabeth Martin TEST - Roth',
            y: -0.584129306219,
          },
        ],
      },
    ],
    categories: [
      'Dean Martin - Roth',
      'Dean Martin - 401(K)',
      'Dean And Elizabeth Martin TEST - Roth',
    ],
  },
};

export const unrealizedGainsLossesMock: {
  tableData: TableData;
  totals: {
    shortTerm: number;
    longTerm: number;
    total: number;
  };
  gainLoss: UnRealizedGainLossDTO[];
} = {
  tableData: {
    headers: [
      {
        text: 'Name',
      },
      {
        text: 'Account Number',
      },
      {
        text: 'Ticker',
      },
      {
        text: 'Units',
      },
      {
        text: 'Price',
      },
      {
        text: 'Market Value',
      },
      {
        text: 'Allocation',
      },
      {
        text: 'Cost Basis',
      },
      {
        text: 'Short Term Gain Loss',
      },
      {
        text: 'Long Term Gain Loss',
      },
      {
        text: 'Gain Loss',
      },
      {
        text: 'Acquired Date',
      },
      {
        text: 'Holding Period',
      },
    ],
    rows: [
      {
        id: '0',
        cells: [
          {
            text: 'Dean Martin, 401(K)',
            align: 'left',
          },
          {
            text: 'XXXXXE-405',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: 2489408.7,
            type: 'currency',
            align: 'right',
          },
          {
            text: 30.472348019879007,
            type: 'percent',
            align: 'right',
          },
          {
            text: 1787620.4296,
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: 714043.5899999999,
            type: 'currency',
            align: 'right',
          },
          {
            text: 714043.5899999999,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'left',
          },
        ],
        childRows: [
          {
            id: '0',
            cells: [
              {
                text: 'Performance Asset',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'PERFORMANCE',
                align: 'right',
              },
              {
                text: 1257774.458,
                align: 'right',
                type: 'number',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 2489408.7,
                align: 'right',
                type: 'currency',
              },
              {
                text: 30.472348019879007,
                align: 'right',
                type: 'percent',
              },
              {
                text: 1787620.4296,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: 714043.5899999999,
                align: 'right',
                type: 'currency',
              },
              {
                text: 714043.5899999999,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 46,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 146.48,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 6738.08,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0.08247947343712037,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: 810.19,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 5927.89,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 5927.89,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2009-05-05T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (6098 days)',
                    align: 'left',
                  },
                ],
              },
              {
                id: '1',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 650,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 146.48,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 95212,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 1.1654708203071356,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: 16063.45,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 79148.55,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 79148.55,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2011-11-21T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (5168 days)',
                    align: 'left',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: '1',
        cells: [
          {
            text: 'Dean Martin, Roth',
            align: 'left',
          },
          {
            text: 'XXXXXE-465',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: 3390002.53,
            type: 'currency',
            align: 'right',
          },
          {
            text: 41.49633480530149,
            type: 'percent',
            align: 'right',
          },
          {
            text: 944850.3728,
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: 2445152.139999999,
            type: 'currency',
            align: 'right',
          },
          {
            text: 2445152.139999999,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'left',
          },
        ],
        childRows: [
          {
            id: '0',
            cells: [
              {
                text: 'Boeing Co',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'BA',
                align: 'right',
              },
              {
                text: 183405.25,
                align: 'right',
                type: 'number',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 3390002.53,
                align: 'right',
                type: 'currency',
              },
              {
                text: 41.49633480530149,
                align: 'right',
                type: 'percent',
              },
              {
                text: 944850.3728,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: 2445152.139999999,
                align: 'right',
                type: 'currency',
              },
              {
                text: 2445152.139999999,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 110,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 76.06,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 8366.6,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0.10241385713126161,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: 3589.13,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 4777.47,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 4777.47,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2007-07-19T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (6754 days)',
                    align: 'left',
                  },
                ],
              },
              {
                id: '1',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 130,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 144.24,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 18751.2,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0.22952964380270513,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: 8196.05,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 10555.15,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 10555.15,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2007-07-19T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (6754 days)',
                    align: 'left',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: '2',
        cells: [
          {
            text: 'Dean Martin, Roth',
            align: 'left',
          },
          {
            text: 'XXXXXXXX65_01',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: 1278536.99,
            type: 'currency',
            align: 'right',
          },
          {
            text: 15.650312508174558,
            type: 'percent',
            align: 'right',
          },
          {
            text: 203154.08,
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'left',
          },
        ],
        childRows: [
          {
            id: '0',
            cells: [
              {
                text: 'Procter & Gamble Co',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'PG',
                align: 'right',
              },
              {
                text: 209139.08,
                align: 'right',
                type: 'number',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 1278536.99,
                align: 'right',
                type: 'currency',
              },
              {
                text: 15.650312508174558,
                align: 'right',
                type: 'percent',
              },
              {
                text: 203154.08,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 203154.08,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 1,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 203154.08,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 2.486767973221248,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: 203154.08,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2026-01-14T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '',
                    align: 'left',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: '3',
        cells: [
          {
            text: 'Dean Martin, Roth',
            align: 'left',
          },
          {
            text: 'XXXXXXXX65_02',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: 999184.78,
            type: 'currency',
            align: 'right',
          },
          {
            text: 12.230818648752308,
            type: 'percent',
            align: 'right',
          },
          {
            text: -49872.41,
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'left',
          },
        ],
        childRows: [
          {
            id: '0',
            cells: [
              {
                text: 'Invesco Developing Markets A',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'ODMAX',
                align: 'right',
              },
              {
                text: -42993.228,
                align: 'right',
                type: 'number',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 999184.78,
                align: 'right',
                type: 'currency',
              },
              {
                text: 12.230818648752308,
                align: 'right',
                type: 'percent',
              },
              {
                text: -49872.41,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: -49872.41,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 1,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 49872.41,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0.61047807622352,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: -49872.41,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2026-01-14T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '',
                    align: 'left',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: '4',
        cells: [
          {
            text: 'Dean And Elizabeth Martin TEST, Roth',
            align: 'left',
          },
          {
            text: 'XXXXXX78911',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: 12269.3,
            type: 'currency',
            align: 'right',
          },
          {
            text: 0.15018601789264313,
            type: 'percent',
            align: 'right',
          },
          {
            text: 281.7,
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            type: 'currency',
            align: 'right',
          },
          {
            text: 0,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'left',
          },
        ],
        childRows: [
          {
            id: '0',
            cells: [
              {
                text: 'Fidelity Cash Fund',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'FCASH',
                align: 'right',
              },
              {
                text: 0.4,
                align: 'right',
                type: 'number',
              },
              {
                text: 1,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0.4,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0.0000048963190367060266,
                align: 'right',
                type: 'percent',
              },
              {
                text: 0.4,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 0.4,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 1,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0.4,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0.0000048963190367060266,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: 0.4,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2026-01-14T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '',
                    align: 'left',
                  },
                ],
              },
            ],
          },
          {
            id: '1',
            cells: [
              {
                text: 'Fidelity OTC',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'FOCPX',
                align: 'right',
              },
              {
                text: 751.183,
                align: 'right',
                type: 'number',
              },
              {
                text: 4.984511,
                align: 'right',
                type: 'currency',
              },
              {
                text: 3744.28,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0.045832973606894103,
                align: 'right',
                type: 'percent',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [],
          },
          {
            id: '2',
            cells: [
              {
                text: 'Fdic Insured Deposit At Wells Fargo Hsa Not Covered By Sipc',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'QPISQ',
                align: 'right',
              },
              {
                text: 5220,
                align: 'right',
                type: 'number',
              },
              {
                text: 0.042146,
                align: 'right',
                type: 'currency',
              },
              {
                text: 220,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0.0026929754701883147,
                align: 'right',
                type: 'percent',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [],
          },
          {
            id: '3',
            cells: [
              {
                text: 'Fidelity Cash Fund**',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'FID:CASH',
                align: 'right',
              },
              {
                text: 281.3,
                align: 'right',
                type: 'number',
              },
              {
                text: 1,
                align: 'right',
                type: 'currency',
              },
              {
                text: 281.3,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0.0034433363625635135,
                align: 'right',
                type: 'percent',
              },
              {
                text: 281.3,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 0,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 281.3,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 1,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 281.3,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0.0034433363625635135,
                    align: 'right',
                    type: 'percent',
                  },
                  {
                    text: 281.3,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 0,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2026-01-14T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '',
                    align: 'left',
                  },
                ],
              },
            ],
          },
          {
            id: '4',
            cells: [
              {
                text: 'FDIC Insured Deposit at Suntrust Bk',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'FDIC94939',
                align: 'right',
              },
              {
                text: 507.5,
                align: 'right',
                type: 'number',
              },
              {
                text: 1,
                align: 'right',
                type: 'currency',
              },
              {
                text: 507.5,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0.006212204777820771,
                align: 'right',
                type: 'percent',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [],
          },
          {
            id: '5',
            cells: [
              {
                text: '3FDIC Insured Deposit 2 At Union Bank HSA',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'FDIC96900',
                align: 'right',
              },
              {
                text: 7515.82,
                align: 'right',
                type: 'number',
              },
              {
                text: 1,
                align: 'right',
                type: 'currency',
              },
              {
                text: 7515.82,
                align: 'right',
                type: 'currency',
              },
              {
                text: 0.09199963135613973,
                align: 'right',
                type: 'percent',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
            ],
            lotDetailsRows: [],
          },
        ],
      },
    ],
  },
  totals: {
    shortTerm: 0,
    longTerm: 3159195.729999999,
    total: 3159195.729999999,
  },
  gainLoss: [],
};

export const unrealizedGainsLossesSummaryMock = {
  shortTerm: 1,
  longTerm: 3159195.72,
  total: 3159195.729999999,
};

export const realizedGainsLossesSummaryMock = {
  shortTerm: 322,
  longTerm: 203858,
  total: 3232323,
};

export const realizedGainsLossesMock: {
  tableData: TableData;
  totals: {
    shortTerm: number;
    longTerm: number;
    total: number;
  };
  gainLoss: RealizedGainLossDTO[];
} = {
  tableData: {
    headers: [
      {
        text: 'Name',
      },
      {
        text: 'Account Number',
      },
      {
        text: 'Ticker',
      },
      {
        text: 'Units',
      },
      {
        text: 'Price',
      },
      {
        text: 'Cost Basis',
      },
      {
        text: 'Short Term Gain Loss',
      },
      {
        text: 'Long Term Gain Loss',
      },
      {
        text: 'Gain Loss',
      },
      {
        text: 'Acquired Date',
      },
      {
        text: 'Sold Date',
      },
      {
        text: 'Holding Period',
      },
      {
        text: 'Proceeds',
      },
    ],
    rows: [
      {
        id: '0',
        cells: [
          {
            text: 'Dean Martin, 401(K)',
            align: 'left',
          },
          {
            text: 'XXXXXE-405',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: 2318013.8,
            type: 'currency',
            align: 'right',
          },
          {
            text: -6908.370000000009,
            type: 'currency',
            align: 'right',
          },
          {
            text: 122498.01000000002,
            type: 'currency',
            align: 'right',
          },
          {
            text: 115589.63999999996,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'left',
          },
          {
            text: 2433603.4399999995,
            type: 'currency',
            align: 'right',
          },
        ],
        childRows: [
          {
            id: '0',
            cells: [
              {
                text: 'Performance Asset',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'PERFORMANCE',
                align: 'right',
              },
              {
                text: 57197.55,
                align: 'right',
                type: 'number',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 2318013.8,
                align: 'right',
                type: 'currency',
              },
              {
                text: -6908.370000000009,
                align: 'right',
                type: 'currency',
              },
              {
                text: 122498.01000000002,
                align: 'right',
                type: 'currency',
              },
              {
                text: 115589.63999999996,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: 2433603.4399999995,
                align: 'right',
                type: 'currency',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 208,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 49.07,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 11958.29,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: -1750.79,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: -1750.79,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2008-01-09T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '2010-01-26T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (748 days)',
                    align: 'left',
                  },
                  {
                    text: 10207.5,
                    align: 'right',
                    type: 'currency',
                  },
                ],
              },
              {
                id: '1',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 120,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 22.08,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 3347.35,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: -697.37,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: -697.37,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2008-01-09T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '2010-01-26T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (748 days)',
                    align: 'left',
                  },
                  {
                    text: 2649.98,
                    align: 'right',
                    type: 'currency',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        id: '1',
        cells: [
          {
            text: 'Dean Martin, Roth',
            align: 'left',
          },
          {
            text: 'XXXXXE-465',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: '',
            type: 'number',
            align: 'right',
          },
          {
            text: 293066.99,
            type: 'currency',
            align: 'right',
          },
          {
            text: 2875.02,
            type: 'currency',
            align: 'right',
          },
          {
            text: 91354.45000000001,
            type: 'currency',
            align: 'right',
          },
          {
            text: 94229.47000000002,
            type: 'currency',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'right',
          },
          {
            text: '',
            align: 'left',
          },
          {
            text: 387296.4600000001,
            type: 'currency',
            align: 'right',
          },
        ],
        childRows: [
          {
            id: '0',
            cells: [
              {
                text: 'Boeing Co',
                align: 'left',
              },
              {
                text: '',
                align: 'right',
              },
              {
                text: 'BA',
                align: 'right',
              },
              {
                text: 20704.72,
                align: 'right',
                type: 'number',
              },
              {
                text: '',
                align: 'right',
                type: 'currency',
              },
              {
                text: 293066.99,
                align: 'right',
                type: 'currency',
              },
              {
                text: 2875.02,
                align: 'right',
                type: 'currency',
              },
              {
                text: 91354.45000000001,
                align: 'right',
                type: 'currency',
              },
              {
                text: 94229.47000000002,
                align: 'right',
                type: 'currency',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: '',
                align: 'left',
              },
              {
                text: 387296.4600000001,
                align: 'right',
                type: 'currency',
              },
            ],
            lotDetailsRows: [
              {
                id: '0',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 100,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 57.09,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 3621.65,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 2087.66,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 2087.66,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2007-07-19T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '2011-04-28T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (1379 days)',
                    align: 'left',
                  },
                  {
                    text: 5709.31,
                    align: 'right',
                    type: 'currency',
                  },
                ],
              },
              {
                id: '1',
                cells: [
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: '',
                    align: 'right',
                  },
                  {
                    text: 80,
                    align: 'right',
                    type: 'number',
                  },
                  {
                    text: 71.64,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 3896.35,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '',
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 1834.95,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: 1834.95,
                    align: 'right',
                    type: 'currency',
                  },
                  {
                    text: '2007-07-19T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: '2012-07-12T00:00:00',
                    align: 'left',
                    type: 'date',
                  },
                  {
                    text: 'LT (1820 days)',
                    align: 'left',
                  },
                  {
                    text: 5731.3,
                    align: 'right',
                    type: 'currency',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  totals: {
    shortTerm: -4033.350000000009,
    longTerm: 213852.46000000002,
    total: 209819.11,
  },
  gainLoss: [],
};

export const projectedIncomeChartMockResponse = {
  chartData: [
    {
      label: 'Feb 2026',
      value: 7923.08,
    },
    {
      label: 'Mar 2026',
      value: 7173.03,
    },
    {
      label: 'Apr 2026',
      value: 9100.68,
    },
    {
      label: 'May 2026',
      value: 8850.18,
    },
    {
      label: 'June 2026',
      value: 10455.34,
    },
    {
      label: 'July 2026',
      value: 6681.55,
    },
    {
      label: 'Aug 2026',
      value: 7923.08,
    },
    {
      label: 'Sept 2026',
      value: 6417.23,
    },
    {
      label: 'Oct 2026',
      value: 6681.55,
    },
    {
      label: 'Nov 2026',
      value: 7923.08,
    },
    {
      label: 'Dec 2026',
      value: 33279.83,
    },
    {
      label: 'Jan 2027',
      value: 6681.55,
    },
  ],
};

export const incomeDetailsMockResponse = {
  columns: [
    {
      key: 'name',
      align: 'left',
      type: 'string',
      header: 'Name',
    },
    {
      key: 'ticker',
      align: 'left',
      type: 'string',
      header: 'Ticker',
    },
    {
      key: 'units',
      align: 'right',
      type: 'number',
      header: 'Units',
    },
    {
      key: 'price',
      align: 'right',
      type: 'currency',
      header: 'Price',
    },
    {
      key: 'marketValue',
      align: 'right',
      type: 'currency',
      header: 'Market Value',
    },
    {
      key: 'allocation',
      align: 'right',
      type: 'percentage',
      header: 'Allocation',
    },
    {
      key: 'annualIncomeRate',
      align: 'right',
      type: 'currency',
      header: 'Annual Income Rate',
    },
    {
      key: 'estimatedAnnualIncome',
      align: 'right',
      type: 'currency',
      header: 'Estimated Annual Income',
    },
    {
      key: 'currentYield',
      align: 'right',
      type: 'percentage',
      header: 'Current Yield',
    },
    {
      key: 'yieldOnCost',
      align: 'right',
      type: 'percentage',
      header: 'Yield on Cost',
    },
  ],
  rows: [
    {
      id: 'Composite--0',
      color: '#0078D4',
      cells: [
        {
          text: 'Composite',
          align: 'left',
        },
        {
          text: '',
          align: 'left',
        },
        {
          text: '',
          align: 'right',
        },
        {
          text: '',
          align: 'right',
        },
        {
          text: '$5,683,306.39',
          align: 'right',
        },
        {
          text: '69.45%',
          align: 'right',
        },
        {
          text: '$2.95',
          align: 'right',
        },
        {
          text: '$106,424.93',
          align: 'right',
        },
        {
          text: '1.85%',
          align: 'right',
        },
        {
          text: '0.03%',
          align: 'right',
        },
      ],
      childRows: [
        {
          cells: [
            {
              text: 'Boeing Co',
              align: 'left',
            },
            {
              text: 'BA',
              align: 'left',
            },
            {
              text: '183,405.25',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$3,423,450.62',
              align: 'right',
            },
            {
              text: '41.84%',
              align: 'right',
            },
            {
              text: '$3.00',
              align: 'right',
            },
            {
              text: '$59,427.35',
              align: 'right',
            },
            {
              text: '1.71%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: 'Invesco Developing Markets A',
              align: 'left',
            },
            {
              text: 'ODMAX',
              align: 'left',
            },
            {
              text: '-42,993.23',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$977,622.92',
              align: 'right',
            },
            {
              text: '11.95%',
              align: 'right',
            },
            {
              text: '$2.45',
              align: 'right',
            },
            {
              text: '$28,869.43',
              align: 'right',
            },
            {
              text: '2.95%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: 'Procter & Gamble Co',
              align: 'left',
            },
            {
              text: 'PG',
              align: 'left',
            },
            {
              text: '209,139.08',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$1,282,232.85',
              align: 'right',
            },
            {
              text: '15.67%',
              align: 'right',
            },
            {
              text: '$3.02',
              align: 'right',
            },
            {
              text: '$18,128.15',
              align: 'right',
            },
            {
              text: '1.41%',
              align: 'right',
            },
            {
              text: '0.12%',
              align: 'right',
            },
          ],
        },
      ],
    },
    {
      id: 'T & R--1',
      color: '#7EC4F6',
      cells: [
        {
          text: 'T & R',
          align: 'left',
        },
        {
          text: '',
          align: 'left',
        },
        {
          text: '',
          align: 'right',
        },
        {
          text: '',
          align: 'right',
        },
        {
          text: '$2,499,794.73',
          align: 'right',
        },
        {
          text: '30.55%',
          align: 'right',
        },
        {
          text: '$1.61',
          align: 'right',
        },
        {
          text: '$20,627.89',
          align: 'right',
        },
        {
          text: '0.81%',
          align: 'right',
        },
        {
          text: '0.00%',
          align: 'right',
        },
      ],
      childRows: [
        {
          cells: [
            {
              text: 'Fidelity Cash Fund',
              align: 'left',
            },
            {
              text: 'FCASH',
              align: 'left',
            },
            {
              text: '0.4',
              align: 'right',
            },
            {
              text: '$1.00',
              align: 'right',
            },
            {
              text: '$0.40',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: 'Fidelity OTC',
              align: 'left',
            },
            {
              text: 'FOCPX',
              align: 'left',
            },
            {
              text: '751.18',
              align: 'right',
            },
            {
              text: '$4.98',
              align: 'right',
            },
            {
              text: '$3,744.28',
              align: 'right',
            },
            {
              text: '0.05%',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: 'Performance Asset',
              align: 'left',
            },
            {
              text: 'PERFORMANCE',
              align: 'left',
            },
            {
              text: '1,257,774.46',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$2,487,525.43',
              align: 'right',
            },
            {
              text: '30.40%',
              align: 'right',
            },
            {
              text: '$1.61',
              align: 'right',
            },
            {
              text: '$20,627.89',
              align: 'right',
            },
            {
              text: '0.81%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: 'Fdic Insured Deposit At Wells Fargo Hsa Not Covered By Sipc',
              align: 'left',
            },
            {
              text: 'QPISQ',
              align: 'left',
            },
            {
              text: '5,220',
              align: 'right',
            },
            {
              text: '$0.04',
              align: 'right',
            },
            {
              text: '$220.00',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: 'Fidelity Cash Fund**',
              align: 'left',
            },
            {
              text: 'FID:CASH',
              align: 'left',
            },
            {
              text: '281.3',
              align: 'right',
            },
            {
              text: '$1.00',
              align: 'right',
            },
            {
              text: '$281.30',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: 'FDIC Insured Deposit at Suntrust Bk',
              align: 'left',
            },
            {
              text: 'FDIC94939',
              align: 'left',
            },
            {
              text: '507.5',
              align: 'right',
            },
            {
              text: '$1.00',
              align: 'right',
            },
            {
              text: '$507.50',
              align: 'right',
            },
            {
              text: '0.01%',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
        {
          cells: [
            {
              text: '3FDIC Insured Deposit 2 At Union Bank HSA',
              align: 'left',
            },
            {
              text: 'FDIC96900',
              align: 'left',
            },
            {
              text: '7,515.82',
              align: 'right',
            },
            {
              text: '$1.00',
              align: 'right',
            },
            {
              text: '$7,515.82',
              align: 'right',
            },
            {
              text: '0.09%',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '$0.00',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
            {
              text: '0.00%',
              align: 'right',
            },
          ],
        },
      ],
    },
  ],
};
